import { t } from '@lingui/core/macro';
import { useState } from 'react';

import { ControlledModal } from '@/components/base/modals/modal';
import { ProfilePictureUpload } from '@/components/profile-picture-upload/profile-picture-upload';

export type PreApplyStep = 'picture';

interface PreApplyModalProps {
  isOpen: boolean;
  userId: string | undefined;
  profileId: string | undefined;
  onCancel: () => void;
  onSuccess: () => void;
  steps: PreApplyStep[];
  initialPhone?: string;
}

export function PreApplyModal({
  isOpen,
  userId,

  onCancel,
  onSuccess,
  steps,
}: PreApplyModalProps) {
  const [stepIndex, setStepIndex] = useState(0);

  const advance = () => {
    if (stepIndex + 1 < steps.length) {
      setStepIndex(stepIndex + 1);
    } else {
      onSuccess();
    }
  };

  const step = steps[stepIndex];

  if (!userId) return null;

  return (
    <ControlledModal
      isOpen={isOpen}
      onOpenChange={(open) => {
        if (!open) onCancel();
      }}
      centered
      title={t`Add a profile picture`}
      className="mx-auto w-full max-w-xl rounded-xl bg-primary p-6 shadow-xl"
    >
      {step === 'picture' && (
        <ProfilePictureUpload
          userId={userId}
          onUploadSuccess={advance}
          onCancel={onCancel}
        />
      )}
    </ControlledModal>
  );
}
